<template>
    <b-modal v-model="isShow"
             :title="title"
             size="lg"
             hide-footer
             no-close-on-backdrop>
        <template #modal-header="{ close }">
            <b-button-close :data-ga-element="gaText"
                            @click="$emit('onClose', close)">
                <b-icon-x :data-ga-element="gaText" />
            </b-button-close>
        </template>
        <div class="px-4 py-4 model-description text-center">{{description}}</div>
        <slot name="action"></slot>
    </b-modal>
</template>

<script>
export default {
    name: 'Modal',
    data() {
        return { isShow: false };
    },
    props: {
        show: Boolean,
        title: String,
        gaText: String,
        description: String,
    },
    watch: {
        show(val) {
            this.isShow = val;
        }
    }
};
</script>

<style scoped lang="scss">
.model-description {
    font-size: 1.125rem;
    color: #666;
}
</style>
